import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import logoMolicar from "./../../../assets/images/logo-molicar.png";
import screenAuthetication from "./../../../assets/images/screen-authetication.png";

import { useTranslation } from "react-i18next";
import { useDecoder, useSessionContext } from "../../../../hooks";
import {
  ButtonLogin,
  ContainerAuthenticationScreen,
  ContainerImage,
  ContainerInfo,
  ContainerInputs,
  FormColumn,
  InputField,
  InputWrapper,
  LogoMolicar,
  MessageLogin,
  Title,
} from "./authentication-screen.molecule.styled";

export const AuthenticationScreenMolecule = (): JSX.Element => {
  const { postAuthToken } = useDecoder();
  const {
    setTokenDecoder,
    clientId,
    clientSecret,
    setClientId,
    setClientSecret,
  } = useSessionContext();
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const clientIdParam = searchParams.get("client_id");
    const clientSecretParam = searchParams.get("client_secret");
    if (clientIdParam) setClientId(clientIdParam);
    if (clientSecretParam) setClientSecret(clientSecretParam);
  }, [location.search, setClientId, setClientSecret]);

  const handleLogin = async () => {
    setError(null);
    setLoading(true);
    try {
      const data = await postAuthToken(clientId, clientSecret);
      setTokenDecoder(data.access_token);
      setClientId(clientId);
      setClientSecret(clientSecret);
      history.push(`/decoder`);
    } catch (err: any) {
      const message = t("AuthenticationWasNotPossible");
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContainerAuthenticationScreen>
      <ContainerImage>
        <img src={screenAuthetication} alt="Authentication Screen" />
      </ContainerImage>
      <ContainerInfo>
        <LogoMolicar>
          <img src={logoMolicar} alt="Logo Molicar" />
        </LogoMolicar>
        <Title>{t("WelcomeDecoder")}</Title>

        <FormColumn>
          <MessageLogin>{t("Login")}</MessageLogin>
          <ContainerInputs>
            <InputWrapper>
              <InputField
                placeholder="client_id"
                value={clientId}
                onChange={(e) => setClientId(e.target.value)}
              />
            </InputWrapper>

            <InputWrapper>
              <InputField
                type="text"
                placeholder="client_secret"
                value={clientSecret}
                onChange={(e) => setClientSecret(e.target.value)}
              />
            </InputWrapper>
            {error && (
              <div style={{ color: "#c0392b", marginTop: 8 }}>{error}</div>
            )}
            <ButtonLogin onClick={handleLogin} disabled={loading}>
              {loading ? t("Entering") : t("ToEnter")}
            </ButtonLogin>
          </ContainerInputs>
        </FormColumn>
      </ContainerInfo>
    </ContainerAuthenticationScreen>
  );
};
